import { InputLabelProps as MUIInputLabelProps } from '@mui/material'
import React from 'react'
import { InputLabelStyled } from './styles'

interface InputLabelProps extends MUIInputLabelProps {
  inline?: boolean
  marginBottom?: number
  id?: string
}

export const Label: React.FC<InputLabelProps> = ({
  htmlFor,
  children,
  inline,
  required,
  className,
  marginBottom,
  id
}) => (
  <InputLabelStyled
    data-testid="label"
    id={id}
    htmlFor={htmlFor}
    inline={inline ? 1 : 0}
    bottom={marginBottom}
    required={required}
    {...(className && { className })}
  >
    {children}
  </InputLabelStyled>
)
